<template>
    <div class="InstagramBusinessContentStoryFeed well p-0 mb-0">
        <InstagramBusinessContentFeed :contents="contents" class="p-5">
            <template v-slot:heading="">
                <i v-tooltip:top="headingLabel" class="fa fa-info info-icon-lg" />
                Story aktivitet
            </template>
        </InstagramBusinessContentFeed>

        <MetricsBar :metrics="metrics" class="py-5 px-5 sm:px-12 border-t border-gray-200" />
    </div>
</template>

<script>
import InstagramBusinessContentFeed from 'dashboard-js/components/influencers/InstagramBusinessContentFeed'
import MetricsBar from 'dashboard-js/components/MetricsBar'
import Tooltip from 'dashboard-js/directives/Tooltip'
import collect from 'collect.js'

export default {
    components: { MetricsBar, InstagramBusinessContentFeed },

    directives: { Tooltip },

    props: ['contents', 'channel'],

    data() {
        return {
            headingLabel:
                'Grafen viser viser influentens aktivitet i formatet “story” og den tilgængelige data.',
        }
    },

    computed: {
        metrics() {
            return [
                {
                    label: 'Gns. eksponeringer',
                    value: this.avgViews,
                    tooltip:
                        'Gennemsnitlig antal eksponeringer for perioden er beregnet på antal opslag divideret med samlet antal eksponeringer.',
                },
                {
                    label: 'Gns. rækkevidde',
                    value: this.avgUniqueViews,
                    tooltip:
                        'Gennemsnitlig rækkevidde for perioden er beregnet på antal opslag divideret med den totale rækkevidde.',
                },
                {
                    label: 'Følger visningsrate',
                    value: this.reachRate,
                    tooltip:
                        'Følger visningsrate for perioden er beregnet på den gennemsnitlige rækkevidde divideret med det totale antal følgere.',
                },
            ]
        },

        avgViews() {
            return Math.round(
                collect(this.contents)
                    .map(item => item.latest_stat.views_total)
                    .avg()
            )
        },

        avgUniqueViews() {
            return Math.round(
                collect(this.contents)
                    .map(item => item.latest_stat.views_unique)
                    .avg()
            )
        },

        reachRate() {
            return Math.round((this.avgUniqueViews / this.channel.reach) * 100).toString() + '%'
        },
    },
}
</script>

<style type="text/less" lang="less"></style>
